export default __webpack_public_path__ + "static/media/ROC.a0a0fd3f.png";